/**
 * Per-Variant Description Switcher
 * Shows/hides variant descriptions on swatch or select change.
 * Same detection pattern as nc-cost-per-can.js.
 */
(function () {
  function init() {
    const container = document.querySelector('[data-variant-desc-container]');
    if (!container || container.dataset.variantDescriptionInitialized === 'true') return;
    container.dataset.variantDescriptionInitialized = 'true';

    const select = document.getElementById('product-select');

    function update() {
      if (!select) return;
      const variantId = select.value;
      for (const el of container.querySelectorAll('[data-variant-desc]')) {
        const isMatch = el.dataset.variantDesc === variantId;
        el.style.display = isMatch ? '' : 'none';
        el.classList.toggle('is-active', isMatch);
      }
      for (const panel of document.querySelectorAll('[data-coho-best-value]')) {
        const isAlwaysVisible = panel.classList.contains('is-always-visible');
        const isMatch = isAlwaysVisible || panel.dataset.cohoBestValue === variantId;
        panel.style.display = isMatch ? 'grid' : 'none';
        panel.classList.toggle('is-active', isMatch);
      }
    }

    // Primary: observe swatch class changes
    const cbv = document.getElementById('callBackVariant');
    if (cbv) {
      new MutationObserver(update).observe(cbv, { attributes: true, attributeFilter: ['class'] });
    }

    // Fallback: select change
    if (select) {
      select.addEventListener('change', update);
    }

    update();
  }

  init();
  document.addEventListener('nc:combined-product:loaded', init);
})();
